import React from "react";

import { Group, Namespace, useTranslate } from "localization";
import { Filter } from "ui/forms";

import useFilterParam from "./useFilterParam";

const Scope3Category: React.FC = () => {
  const { translate } = useTranslate(Namespace.DEFAULT, Group.SCOPE_3);
  const title = translate("title");

  const data = Object.entries(
    translate("scope3CategoryNames", {
      returnObjects: true,
    })
  )
    .slice(1) // Skip the first entry {[0]: null}
    .map(([key, value]) => ({
      label: value,
      value: key,
    }));

  const [selected, setSelected] = useFilterParam("scope3Category", data, {
    defaultToFirst: false,
    multi: true,
    ready: true,
  });
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={setSelected}
      disabled={!data.length || !selected}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      translate={translate}
      searchable
    />
  );
};

export default Scope3Category;
